import axios     from "axios";
import { store } from "@/store";

const http = axios.create({
    baseURL: store.getters.host,
});

http.interceptors.request.use(
    function (config) {
        config.headers["Authorization"] = `Bearer ${ store.getters.user.token }`;
        config.headers["Accept-Language"] = store.getters.locale;
        return config;
    }
);

export { http };